import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "antd";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import CandidateTestCard from "./CandidateTestCard";
import { Test } from "../types/Test";
import { useCart } from "../contexts/CartContext";
import { toast } from "react-toastify";

interface Props {
	id: number;
}

const AssociatedTests: React.FC<Props> = ({
	id,
}) => {
	const [associated, setAssociated] = useState<Test[]>([]);
	const { addItem, isInCart } = useCart();
	const navigate = useNavigate();

	useEffect(() => {
		fetchAssociated();
	}, []);

	// Get associated assessments
	const fetchAssociated = async () => {
		try {
			const response = await api.get(`test-associated/?test_id=${id}`);
			console.log(response);
			setAssociated(response.data);
		} catch (error) {
			console.error('Failed to fetch associated assessments:', error);
			setAssociated([]);
		}
	};

	const handleAddAllToCart = () => {
		let hasChanged = false;
		associated.forEach((item) => {
			if (!isInCart(item.id)) {
				addItem({
					id: item.id,
					name: item.name,
					price: item.price,
					industry_name: item.industry_name,
					industry_color: item.industry_color,
				});
				hasChanged = true;
			}
		});
		const message = hasChanged ? "Associated assessments added to cart!" : "Associated assessments are already in the cart!";
		toast.success(message);
	};

	// Place into single cards
	return (
		<div>
			{associated.length > 0 && Array.isArray(associated) && (
				<div style={container}>
					<h2 style={title}>Other assessments you might like</h2>
					<Row style={row} gutter={[32, 0]}>
						{associated.map((test) => (
							<Col xs={24} sm={12} xl={8}>
								<CandidateTestCard
									id={test.id}
									title={test.name}
									price={test.price}
									questionCount={test.question_count}
									timeLimit={String(test.time_limit)}
									description={test.description ?? ""}
									industryTags={[test.industry_name]}
									industryColor={test.industry_color}
									inCart={isInCart(test.id)}
									showCart={true}
									onClick={() => navigate(`/test-details?test_id=${test.id}`)}
								/>
							</Col>
						))}
					</Row>
					<button onClick={handleAddAllToCart} style={addCart}>Add all to cart</button>
				</div>
			)}
		</div>
	);
};

const container: React.CSSProperties = {
	margin: "1.5rem auto",
	width: "95%"
};

const row: React.CSSProperties = {
	marginBottom: 40
};

const title: React.CSSProperties = {
	fontWeight: "bold",
	marginBottom: "1.5rem"
};

const addCart: React.CSSProperties = {
	margin: "0 auto",
	display: "block",
	color: "white",
	border: "none",
	outline: "none",
	borderRadius: "999px",
	background: "#1D1F48",
	fontSize: 14,
	width: 189,
	height: 38,
	fontWeight: "bold"
};

export default AssociatedTests;